// 时间格式化
export var timeFormat = function (time) {
    if (!time) {
        return;
    }
    return time.replace(/-/gi, '.');
};
// 去掉空格
export var trim = function (val) {
    if (!val) {
        return;
    }
    return val.replace(/^\s*|\s*$/, '');
};
// 超出99 显示99+
export var hundred = function (num) {
    if (num > 99) {
        return '99+';
    }
    else if (num) {
        return num;
    }
    else {
        return 0;
    }
};
// 将数组变成字符串
export var arrToStr = function (arr) {
    if (arr && arr.length) {
        return arr.join('、');
    }
    return arr || '';
};
// 取数组每个对象下某个属性的值组成字符串
export var objArrToStr = function (arr, type) {
    if (!arr)
        return;
    return arr.map(function (item) { return item[type]; }).join('、');
};
// 保留两个小数
export var twoPoint = function (num) {
    var a = num * 1;
    var b = a.toFixed(2);
    return b;
};
// 保留两个小数，并获取到小数点前面的
export var twoPointPre = function (num) {
    var a = num * 1;
    var b = "" + a.toFixed(2);
    return b.split('.')[0];
};
// 保留两个小数，并获取到小数点后面的
export var twoPointNext = function (num) {
    var a = num * 1;
    var b = "" + a.toFixed(2);
    return b.split('.')[1];
};
// 剔除数组对象下**字段值为**的对象
export var arrObjectFilter = function (arr, key, value) {
    var res = arr.filter(function (item) {
        return item[key] !== value;
    });
    return res;
};
// 数组对象去重
export var arrObjectNoRepeat = function (arr, key) {
    var obj = {};
    var newArr = arr.reduce(function (item, next) {
        if (!obj[next[key]]) {
            obj[next[key]] = true && item.push(next);
        }
        return item;
    }, []);
    return newArr;
};
// 月份转季度
export var monthToQuarter = function (month) {
    if (month > 0 && month < 4) {
        return 1;
    }
    else if (month > 3 && month < 7) {
        return 2;
    }
    else if (month > 6 && month < 10) {
        return 3;
    }
    else if (month > 9 && month < 13) {
        return 4;
    }
};
// 阿拉伯数字对应中文
export var digitsName = function (num) {
    var name = '一';
    switch (num) {
        case 1:
            name = '一';
            break;
        case 2:
            name = '二';
            break;
        case 3:
            name = '三';
            break;
        case 4:
            name = '四';
            break;
        case 5:
            name = '五';
            break;
        case 6:
            name = '六';
            break;
        case 7:
            name = '七';
            break;
        case 8:
            name = '八';
            break;
        case 9:
            name = '九';
            break;
    }
    return name;
};
/**
 * 将接口返回的秒转换为3h3min2s的格式
 * @param {*} s
 */
export var getHMinSec = function (second) {
    if (!second) {
        return 0;
    }
    if (second < 60) {
        return second + "s";
    }
    else {
        var hourMin = 60; // 1小时 = 60分
        var hourSecond = 60 * 60; // 1小时 = 3600s
        var h = Math.floor(second / hourSecond); // 小时
        var min = Math.floor((second % hourSecond) / hourMin); // 分钟
        var s = (second % hourSecond) % 60; // 秒
        return "" + (h ? h + "h" : '') + (min ? min + "min" : "" + (h && s ? "0min" : '')) + (s ? s + "s" : '');
    }
};
/**
 * 将接口返回的秒转换为433min2s的格式
 * @param {*} s
 */
export var getMinSec = function (second) {
    if (!second) {
        return 0;
    }
    if (second < 60) {
        return second + "s";
    }
    else {
        var minSec = 60; // 1分钟 = 60秒
        var min = Math.floor(second / minSec); // 分钟
        var s = second % minSec; // 秒
        return "" + (min ? min + "min" : '') + (s ? s + "s" : '');
    }
};
